var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card"
  }, [_c('div', {
    staticClass: "order-card__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.images[0].pic_url
    }
  })]), _c('div', {
    staticClass: "order-card__content"
  }, [_c('div', {
    staticClass: "order-card__date"
  }, [_vm._v(_vm._s("".concat(_vm.startDate, " ~ ").concat(_vm.endDate)))]), _c('div', {
    staticClass: "order-card__title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('div', {
    staticClass: "order-card__subtitle"
  }, [_vm._v(_vm._s(_vm.sku.sku_name))]), _c('div', {
    staticClass: "order-card__created-at"
  }, [_vm._v("跟團時間：" + _vm._s(_vm.createdAt))]), _c('div', {
    staticClass: "order-card__button"
  }, [_vm.coupon ? _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs btn-exchange",
    attrs: {
      "type": "button",
      "disabled": _vm.buttonText != '查看優惠券'
    },
    on: {
      "click": _vm.handleExchange
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }